import { States } from 'safe'
import { SET_CURRENCIES, CurrenciesTypes } from '../actions/actionTypes'

const initialState: States.Currency = {
  currencies: [],
}

//eslint-disable-next-line
export default (
  state = initialState,
  action: CurrenciesTypes
): States.Currency => {
  switch (action.type) {
    case SET_CURRENCIES:
      const currencies: any = action.payload.map((currency) => ({
        ...currency,
        //@ts-ignore
        name: currency.id == '2' ? 'BOLIVAR' : currency.name,
      }))
      return { ...state, currencies }
    default:
      return state
  }
}
